const hero = document.querySelector('.s-hero');

if (hero) {
	// --- Skala sceny w silnikach bez CSS Values 4 ---------------------------
	// `--k` w s-hero.scss dzieli długość przez długość (`100vw / 1440 / 1px`).
	// Firefox tego nie obsługuje, więc tam deklaracja jest nieprawidłowa,
	// a `@property --k` (patrz góra s-hero.scss) daje wyłącznie fallback k = 1:
	// hero jest widoczne, ale w naturalnym rozmiarze, bez dopasowania do okna.
	// Poprawną skalę dokładamy tutaj.
	//
	// Detekcja sprawdza dokładnie tę arytmetykę, której brakuje (Firefox false,
	// Chrome true). NIE wolno użyć do tego `tan(atan2(100vw, 1px))` — CSS.supports
	// zwraca dla niego true także w Firefoksie, gdzie i tak nie działa.
	const supportsLengthRatio = window.CSS
		&& typeof window.CSS.supports === 'function'
		&& window.CSS.supports('width', 'calc(100px / 1px * 1px)');

	if (!supportsLengthRatio) {
		const CAP = 1.334; // 1920 / 1440

		// Rozmiary sceny czytamy z CSS, a nie powtarzamy tu liczbami: zaślepka
		// (.s-hero--tease) ma inne --stage-h, zeruje --nav-h i --sq, a każda
		// zmiana w s-hero.scss musiałaby inaczej pamiętać o tym pliku.
		const isTease = hero.classList.contains('s-hero--tease');
		const cssNum = (name) => parseFloat(getComputedStyle(hero).getPropertyValue(name)) || 0;

		const computeK = (vw, vh) => {
			const stageW = cssNum('--stage-w');
			const stageH = cssNum('--stage-h');
			const navH = cssNum('--nav-h');

			// md i lg różnią się tylko wartościami --stage-w/--stage-h
			if (vw >= 768) {
				return Math.min(vw / stageW, (vh - navH) / stageH, CAP);
			}

			// mobilna zaślepka skaluje się wyłącznie szerokością okna
			if (isTease) {
				return vw / stageW;
			}

			// mobile: wysokość liczona do linii cięcia po zabraniu granatu nad
			// tytułem (720 - 58 = 662), z dolną granicą vw / 390 = zasięg
			// klinów (patrz --cut-h, --sq i --fill-w w s-hero.scss)
			return Math.max(vw / cssNum('--fill-w'), Math.min(vw / stageW, (vh - navH) / cssNum('--cut-h')));
		};

		const applyScale = () => {
			// max(.1, …) jak w CSS: ujemne --k odbiłoby scenę lustrzanie,
			// gdyby okno było niższe niż belka nawigacji
			const k = Math.max(.1, computeK(window.innerWidth, window.innerHeight));

			hero.style.setProperty('--k', String(k));
		};

		let frame = 0;
		const schedule = () => {
			if (frame) {
				return;
			}

			frame = requestAnimationFrame(() => {
				frame = 0;
				applyScale();
			});
		};

		applyScale();

		if (window.ResizeObserver) {
			new ResizeObserver(schedule).observe(document.documentElement);
		} else {
			window.addEventListener('resize', schedule);
		}

		window.addEventListener('orientationchange', schedule);
	}

	// --- Animacja wejścia --------------------------------------------------
	// `will-change` na 16 warstwach jest potrzebny tylko na czas wejścia —
	// .is-done zdejmuje go (patrz s-hero.scss). 2200ms = najdłuższy
	// transition-delay (1.2s) + czas trwania (.6s) z zapasem.
	const ANIMATION_TOTAL = 2200;

	const reveal = () => {
		// rAF: pozwól przeglądarce policzyć stan początkowy, inaczej transition
		// nie ma od czego startować i element pojawia się skokiem
		requestAnimationFrame(() => {
			hero.classList.add('is-ready');
			setTimeout(() => hero.classList.add('is-done'), ANIMATION_TOTAL);
		});
	};

	if (document.fonts && document.fonts.ready) {
		// Promise.race z limitem czasu: bez niego sekcja zostaje na opacity: 0
		// dopóki wszystkie woff2 się nie wczytają (albo w nieskończoność, gdy
		// któryś padnie) — użytkownik widzi puste granatowe pole, a LCP strony
		// głównej leci w dół. 800ms to kompromis: tyle wystarcza fontom
		// z preloadu (patrz base.html.twig), a dłużej nie każemy nikomu czekać.
		Promise.race([
			document.fonts.ready,
			new Promise((resolve) => setTimeout(resolve, 800)),
		]).then(reveal);
	} else {
		reveal();
	}
}
